angular.module('cian.offer.services', [])
.factory('OfferService', ["$window", "$http", "$q", "$rootScope", '$log', function($window, $http, $q, $rootScope, $log) {
    var service = {};

    service.updateOffers = function (data) {
      $window._offers = data.json;
    }

    function _transformRequest(obj) {
      var str = [];
      for(var p in obj)
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      return str.join("&");
    }

    service.getModel = function(oid) {
      return $window._offers[oid] || $window._similarOffers[oid];
    };

    service.saveModel = function(offer) {
      if ($window._offers[offer.id]) {
        $window._offers[offer.id] = angular.extend({}, $window._offers[offer.id], offer);
      } else {
        $window._similarOffers[offer.id] = angular.extend({}, $window._similarOffers[offer.id], offer);
      }
    };

    service.saveNote = function(offer, text) {
      return $http({
        url: offer.note.api[0],
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: {
          text: text,
          action: text ? 'save' : 'delete',
          oid: offer.id
        }
      }).success(function(data) {
        if (data.status === 'ok') {
          offer.note.text = text;
          service.saveModel(offer);
        }
      });
    };

    service.saveUserNote = function(offer, text) {
      return $http({
        url: offer.user.note.api,
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: {
          text: text,
          action: text ? 'save' : 'delete',
          rid: offer.user.id
        }
      }).success(function(data) {
        if (data.status === 'ok') {
          offer.user.note.text = text;
          service.saveModel(offer);
        }
      });
    };

    service.toggleFavorite = function(offer) {
      var def = $q.defer();
      // Сразу переключаем, чтобы предотвратить лаг, когда мы ждем ответа от API
      offer.favorite.state = !offer.favorite.state;

      if (window._dataLayerBackedObject && window._dataLayerBackedObject.page.pageType === 'Card') {
        ca('event', {
          name: 'oldevent',
          category: 'favorite',
          action: offer.favorite.state ? 'add_from_card_heart' : 'remove_from_card_heart',
          label: offer.ga_event_action,
      });
      }

      if (window._dataLayerBackedObject && window._dataLayerBackedObject.page.pageType === 'Listing') {
        window.ca && window.ca('event', {
          name: 'oldevent',
          category: 'favorite',
          action: offer.favorite.state ? 'add_from_newlist' : 'remove_from_newlist',
          label: offer.ga_event_action,
        });
      }

      service.saveModel(offer);

      $http({
        url: offer.favorite.api,
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: {
          action: offer.favorite.state?'assign':'remove',
          oid: offer.id
        }
      }).success(function(data) {
        window.refreshAfterUserLoggedIn();
        if (data.status !== 'ok') {
          offer.favorite.state = !offer.favorite.state;
          service.saveModel(offer);
          def.reject('Error adding favorite');
        } else {
          def.resolve({offer: offer, count: data.count});
        }
      })
      .error(function() {
        window.refreshAfterUserLoggedIn();
        offer.favorite.state = !offer.favorite.state;
        service.saveModel(offer);
        def.reject('Error adding favorite');
      });

      return def.promise;
    };

    service.getPremiumPrice = function(offer) {
      var def = $q.defer();

      $http({
        url: offer.premium.api.info,
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: {
          mode: 'getprice',
          deal_type: offer.deal_type,
          offer_type: offer.offer_type,
          oid: offer.id
        }
      }).success(function(data) {
        if (data.status === 'ok') {
          // offer.premium.price = data.data.price;
          // service.saveModel(offer);
          def.resolve(data.data);
        } else {
          def.reject(data);
        }
      }).error(function() {
        def.reject('error');
      });

      return def.promise;
    };

    service.prolong = function(offer) {
      var def = $q.defer();

      $http({
        url: offer.prolong.api,
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: {
          deal_type: offer.deal_type,
          offer_type: offer.offer_type,
          oid: offer.id,
          json: 1
        }
      }).success(function(data) {
        if (data.status === 'ok') {
          offer.added.humanized = data.data.humanized;
          offer.added.strict = data.data.strict;
          delete offer.prolong;
          service.saveModel(offer);
          def.resolve(data);
        } else if (data.status === 'error') {
          def.reject(data.data.object.message);
        }
      })
      .error(function() {
        def.reject('Error while offer publish date prolongation. Offer id: ' + offer.id);
      });

      return def.promise;
    };

    service.remove = function(offer) {
      return $http({
        url: offer.remove.api,
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: {
          deal_type: offer.deal_type,
          offer_type: offer.offer_type,
          oid: offer.id,
          json: 1
        }
      }).success(function(data) {
        if (data.status === 'ok') {
          offer.remove.state = true;
          service.saveModel(offer);
        }
      });
    };

    service.setPremium = function(offer, extra) {
      var def = $q.defer();

      $http({
        url: offer.premium.api.set,
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: {
          deal_type: offer.deal_type,
          offer_type: offer.offer_type,
          period: extra.period,
          secret_code: extra.secretCode,
          code_required: extra.isCodeRequired,
          oid: offer.id
        }
      }).success(function(data) {
        if (data.status === 'ok') {
          offer.premium.state = true;
          service.saveModel(offer);
          def.resolve(data.data.message);
        } else {
          def.reject((data.data.object && data.data.object.message) || 'Произошла ошибка при активации премиум-статуса');
        }
      })
      .error(function() {
        def.reject('Error while setting premium status. Offer id:' + offer.id);
      });

      return def.promise;
    };

    service.unsetPremium = function(offer, extra) {
      return $http({
        url: offer.premium.api.unset,
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: {
          deal_type: offer.deal_type,
          offer_type: offer.offer_type,
          oid: offer.id,
          json: 1
        }
      }).success(function(data) {
        if (data.status === 'ok') {
          offer.premium.state = false;
          service.saveModel(offer);
        } 
      });
    };

    service.recover = function(offer) {
      return $http({
        url: offer.recover.api,
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: {
          deal_type: offer.deal_type,
          offer_type: offer.offer_type,
          oid: offer.id,
          json: 1
        }
      }).success(function(data) {
        $log.debug(data);
        // if (data.status === 'ok') {
        //   offer.premium.state = false;
        //   service.saveModel(offer);
        // }
      });
    };

    service.reclaim = function(offer) {
      var def = $q.defer();

      $http({
        url: '/integration/offer/can_load/',
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: {
          deal_type: offer.deal_type,
          offer_type: offer.offer_type,
          oid: offer.id,
          'import': 1,
          json: 1
        }
      }).success(function(data) {
        if (!data.status || data.status == 'error') {
            var content = 'Внутренняя ошибка сервера, попробуйте повторить попытку позже.';
            if (data.data && data.data.object){
                content = data.data.object.message;
            } else if (data.data && data.data.message) {
                content = data.data.message;
            }
            def.reject(content);
        } else {
          def.resolve(offer);
        }
      }).error(function() {
        def.reject('Could not reclaim offer. Offer ID: ' + offer.id);
      });

      return def.promise;
    };

    service.getPremiumPeriods = function() {
      var periods = [
        { text: 'бессрочно', value: 0   },
        { text: '14 дней',   value: 14  },
        { text: '13  дней',  value: 13  },
        { text: '12 дней',   value: 12  },
        { text: '11 дней',   value: 1   },
        { text: '10 дней',   value: 10  },
        { text: '9 дней',    value: 9   },
        { text: '8 дней',    value: 8   },
        { text: '7 дней',    value: 7   },
        { text: '6 дней',    value: 6   },
        { text: '5 дней',    value: 5   },
        { text: '4 дней',    value: 4   },
        { text: '3 дней',    value: 3   },
        { text: '2 дней',    value: 2   },
        { text: '1 дней',    value: 1   }
      ];

      return periods;
    };

    service.getComplaintReasons = function(category_id) {
      var def = $q.defer();
      $http
        .get('/ajax/complaints/get/' + category_id +'/')
        .then(function(res, data) {
          if (res.data && res.data.status === 'ok') {
            def.resolve(res.data.data);
          } else {
            def.reject('Attempt to get reasons data has failed');
          }
        }, function() {
          def.reject('Attempt to get reasons data has failed');
        });

      return def.promise;
    };

    /* Используя существующий формат reasons.json, модифицурем объект с данным для того,
    ** чтобы было комфортно работать в контроллере
    */
    function _transformReasonsData(data, deal_type, offer_type) {
      var sections = angular.extend({}, data.simple.columns[0], data.simple.columns[1]),
          sectionsTransformed = [];
      angular.forEach(sections, function(obj, key) {
        var item = {
          'text': key,
          'reasons': []
        },
        reasons = obj[deal_type][offer_type],
        reasonsTransformed = [];

        for (var i = 0; i < reasons.length; i++) {
          for (var k = 0; k < data.reasons.length; k++) {
            if (reasons[i] == data.reasons[k].code) {
              reasonsTransformed.push(data.reasons[k]);
            }
          }
        }
        item.reasons = reasonsTransformed;
        sectionsTransformed.push(item);
      });

      return sectionsTransformed;
    }

    service.sendComplaint = function(offer, reason_id, reason_name, message) {
      return $http({
        url: offer.complain.api,
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        // params: {
        //   reasons: reasons
        // },
        data: {
          realty_id: offer.realty_id,
          block_id: reason_id,
          message: message || '',
          name: reason_name
        }
      });
    };

    service.toggleRating = function(offer, rating) {
      var currentRating = offer.user.rating.state,
          newRating = 'neutral';

      if (currentRating === 'neutral' || currentRating !== rating) {
        newRating = rating;
      }

      return $http({
        url: offer.user.rating.api,
        method: 'POST',
        transformRequest: _transformRequest,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: {
          rid: offer.user.id,
          action: 'vote',
          rating: newRating
        }
      })
      .success(function(data) {
        if (data.status === 'ok') {
          offer.user.rating.state = newRating;
          service.saveModel(offer);
        }
      });
    };

    return service;
  }]);



//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.offer.services.js
// module id = 492
// module chunks = 0